export const getToken = () => {
    return localStorage.getItem('services.fc.token')
}

export const setToken = (api : String) => {
    localStorage.setItem('services.fc.token', api.toString())
}

export const removeToken = () => {
    localStorage.removeItem('services.fc.token')
}